module.exports = __webpack_public_path__ + "static/media/ic_chevron_right_grey.fa29efdc.svg";